import { render, staticRenderFns } from "./VerkaTeaserBox.vue?vue&type=template&id=03172c70&scoped=true&"
import script from "./VerkaTeaserBox.vue?vue&type=script&lang=ts&"
export * from "./VerkaTeaserBox.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaTeaserBox.vue?vue&type=style&index=0&id=03172c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03172c70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
